export default __webpack_public_path__ + "static/media/nodejs.ce9d1329.svg";